@if (layout() === 'private') {
  <app-vertical-layout>
    <router-outlet />
  </app-vertical-layout>
}
@if (layout() === 'blank') {
  <app-blank-layout>
    <router-outlet />
  </app-blank-layout>
}
<app-screen-loader-component [isLoading]="_isLoadingApplication()"></app-screen-loader-component>
<ngx-sonner-toaster position="bottom-center" [duration]="3000" />
<!-- Announces SPA route changes to screen readers (route changes are otherwise silent to AT). -->
<div aria-live="polite" aria-atomic="true" role="status" class="sr-only">{{ pageTitle() }}</div>
